<template>
    <div>
      <b-loading :active.sync="loading" />
      <div class="w-full flex justify-between items-center">
        <Lynx-Title text="Exportação de relatórios" />
      </div>
  
      <div class="w-full flex mt-8 grid grid-cols-2 gap-8 items-start">
        <Card
          class="font-body cursor-pointer"
          color="primary-500"
          @click.native="emissor = true"
        >
          <div>
            <div class="p-6 flex items-start">
              <div class="flex flex-col ml-4">
                <p class="font-semibold pb-4 text-primary-800">
                  Empresas, Prefeitura por carteira
                </p>
                <p class="font-semibold text-primary-800">
                  <span class="text-neutral-800 font-normal text-neutral-700"
                    >Empresas, acesso do emissor de notas, cidade por
                    carteira</span
                  >
                </p>
              </div>
            </div>
          </div>
        </Card>
        <Card
        class="font-body cursor-pointer"
        color="primary-500"
        @click.native="ModelAberturaDias = true"
      >
        <div>
          <div class="p-6 flex items-start">
            <div class="flex flex-col ml-4">
              <p class="font-semibold pb-4 text-primary-800">
                Relatorios das Empresas Abertura Dias e Status
              </p>
              <p class="font-semibold text-primary-800">
                <span class="text-neutral-800 font-normal text-neutral-700"
                  >Empresas com status e dias que estão presas no mesmo
                </span>
              </p>
            </div>
          </div>
        </div>
      </Card>
      <Card
        class="font-body cursor-pointer"
        color="primary-500"
        @click.native="exportRelatorio2('empresas/relatorio/data-ativacao')"
      >
        <div>
          <div class="p-6 flex items-start">
            <div class="flex flex-col ml-4">
              <p class="font-semibold pb-4 text-primary-800">
                Relatorio Data Empresas Ativas  
              </p>
              <p class="font-semibold text-primary-800">
                <span class="text-neutral-800 font-normal text-neutral-700"
                  >Data de ativação da Empresa conforme historico registrado
                </span>
              </p>
            </div>
          </div>
        </div>
      </Card>
      <Card
        class="font-body cursor-pointer"
        color="primary-500"
        @click.native="exportRelatorio2('empresas/relatorio/logs-etapas')"
      >
        <div>
          <div class="p-6 flex items-start">
            <div class="flex flex-col ml-4">
              <p class="font-semibold pb-4 text-primary-800">
                Relatorios Logs Das Etapas da Empresa
              </p>
              <p class="font-semibold text-primary-800">
                <span class="text-neutral-800 font-normal text-neutral-700"
                  >Data,carteira e etapa das Empresas conforme historico registrado
                </span>
              </p>
            </div>
          </div>
        </div>
      </Card>
        <Card
        class="font-body cursor-pointer"
        color="primary-500"
        @click.native="exportRelatorio2('empresas/poscadastro/relatorioTransferidas')"
      >
        <div>
          <div class="p-6 flex items-start">
            <div class="flex flex-col ml-4">
              <p class="font-semibold pb-4 text-primary-800">
                Relatorios de todas as empresas transferidas
              </p>
              <p class="font-semibold text-primary-800">
                <span class="text-neutral-800 font-normal text-neutral-700"
                  >id,razão social, criação e carteiras das empresas transferidas
                </span>
              </p>
            </div>
          </div>
        </div>
      </Card>
  
      </div>
      <b-modal :active.sync="emissor" v-b-modal.modal-lg can-cancel>
        <div class="bg-neutral-300 shadow p-10">
          <Lynx-Title text="Exportar" />
          <h2 class="pb-8 text-xl font-display text-primary-900">
            Lista de Empresas, acesso do emissor de notas, cidade por carteira
          </h2>
          <div class="flex flex-wrap">
            <!-- <Lynx-Button text="Todas" class="mr-2" @click.native="exportReport" /> -->
  
            <Lynx-Button
              v-show="
                (item.setor === 'Abertura e Legalização') ? true : false
              "
              v-for="(item, key) in lista_carteiras"
              :key="key"
              :text="item.nome"
              class="mr-2 mt-1"
              @click.native="exportReport({ key: 'carteira', value: item.id })"
            />
  
            <!-- <Lynx-Button  text="Congeladas" class="mr-2 mt-1" @click.native="exportReport({key: 'congelada', value: true})" v-if="$hasPermission('exportar relatorio congeladas')"/> -->
          </div>
        </div>
      </b-modal>
      <b-modal :active.sync="ModelAberturaDias" can-cancel>
      <div class="bg-neutral-300 shadow p-8">
        <div class="modal-body" style="height: 420px">
          <Lynx-Title text="Exportar" />

          <div class="w-full flex flex-wrap">
            <label class="flex flex-col w-2/4 pl-2 pb-6">
              <Lynx-Label label="Insira o(s) Status" />

              <treeselect
                :multiple="true"
                :options="lista_status"
                placeholder="Selecione Os Status..."
                v-model="form.status"
              />
            </label>
            <label class="flex flex-col w-1/4 pl-2 pb-6">
              <Lynx-Label label="Quantidade de Dias" />
              <Lynx-Input
                placeholder="Insira Quantidade de Dias"
                v-model="form.quantDay"
              />
            </label>
          </div>
          <Lynx-Button
            text="Exportar"
            class="mr-2"
            @click.native="exportAberturaDays"
          />
        </div>
      </div>
    </b-modal>
  
    </div>
  </template>
  
  <script>
  import Card from "@/components/helpers/Card";
  import Treeselect from "@riophae/vue-treeselect";
  
  export default {
    components: { Card, Treeselect },
    name: "index",
    data() {
      return {
        loading: false,
        emissor: false,
        irpf: false,
        docieIrpf: false,
        ano: null,
        cliente: null,
        ModelEmpresasRelataorio: false,
        ModelAberturaDias: false,
        lista_status: [
          { id: 1, label: "Processando" },
          { id: 2, label: "Aguardando assinatura" },
          { id: 3, label: "Aguardando certificado" },
          { id: 4, label: "Aguardando CNPJ" },
          { id: 5, label: "Aguardando alvará" },
          { id: 6, label: "Aguardando acesso" },
          { id: 7, label: "Aguardando simples" },
          { id: 8, label: "Aguardando Documentação" },
          { id: 9, label: "Pré-cadastro" },
          { id: 99, label: "Aguardando ativação" },
        ],
  
        form: {
          quantDay: "",
          status: [],
        },
      };
    },
    computed: {
      lista_carteiras() {
        //  return this.$store.state.carteira.lista_carteiras;
  
        return this.$store.state.carteira.lista_carteiras;
      },
    },
    created() {
      this.listar_carteiras();
    },
    methods: {
      listar_carteiras() {
        this.$store.dispatch("carteira/listar_carteiras");
      },
      exportReport(param = null) {
        let filter;
        if (param != null) {
          filter = `&${param.key}=${param.value}`;
        }
        window.open(
          `${process.env.VUE_APP_API_URL}/reports/1?token=${this.$store.getters.getToken}${filter}`,
          "_blank"
        );
      },
 
      exportRelatorio(nome) {
        window.open(
          `${process.env.VUE_APP_API_URL}/relatorio/` +
            nome +
            `?token=${this.$store.getters.getToken}`,
          "_blank"
        );
      }, 
         exportRelatorio2(nome) {
        window.open(
          `${process.env.VUE_APP_API_URL}/` +
            nome +
            `?token=${this.$store.getters.getToken}`,
          "_blank"
        );
      },
      async exportAberturaDays() {
        this.loading = true;
        await this.$store.dispatch(
          "finanRelatorio/gerarRelatorioAberturaDays",
          this.form
        );
        this.loading = false;
      },
    },
  };
  </script>
  
  <style scoped>
  </style>
  